
import React, { useEffect, useRef, useState } from "react";
import {
  NuInput,
  NuTextArea,
  NuTextAreaForm,
} from "../../../../Components/Utils/Input";
import { useFormik } from "formik";
import * as yup from "yup";
import axiosInstance from "../../../../Services/axiosCommon";
import { useParams } from "react-router-dom";
import { useToast } from "../../../../Components/Others/ToastServices";
import EditIcon from "../../../../Components/Icons/Edit";
import { GetAccess, GetRole } from "../../../../Components/Utils/roles";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import {
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import SignatureCanvas from "react-signature-canvas";
import SendOTP from "./SendOTP";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Attachement, {
  videotype,
} from "../../../../Components/Utils/CustomAttrachmentupload";
import CloseIcon from "../../../../Components/Icons/Close";
import Video from "../../../../Components/Icons/Video";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";
import ToggleDown from "../../../../Components/Icons/ToggleDown";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import NuDate from "../../../../Components/Utils/NuDate";
import FireSuppressionLayout from "./FireSupressionLayout";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import { Delete } from "lucide-react";
import DeleteIcon from "../../../../Components/Icons/Delete";


function FeFormView() {
  // Signature Refs
  const signOne = useRef(null);
  const signTwo = useRef(null);

  // Signature URLs
  const [signOneURL, setSignOneURL] = useState(null);
  const [signTwoURL, setSignTwoURL] = useState(null);

  // Signature Toggles
  const [isSignOneEnabled, setIsSignOneEnabled] = useState(false);
  const [isSignTwoEnabled, setIsSignTwoEnabled] = useState(false);
  // Signature Action Buttons
  const [showActionButtonsOne, setShowActionButtonsOne] = useState(false);
  const [showActionButtonsTwo, setShowActionButtonsTwo] = useState(false);

  const { fireSuppressionViewId,id } = useParams();
  const [editModeIndex, setEditModeIndex] = useState(null);
  const [formSubmitId, setFormSubmitId] = useState(null);
  const toast = useToast();

  // Fetch dropdown data
 const { value: suppression, getData: refsuppression } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "suppression"
    );

  const { value: unit, getData: refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );

  const [allFormValues, setAllFormValues] = useState([]);
  const [allForm, setAllForm] = useState([]);
  const [allValue, setAllValue] = useState([]);
  const [isSubmittted, setIsSubmittted] = useState(false);
  const [rows, setRows] = useState([]);
  const [isEditing, setIsEditable] = useState(false);
  const [open, setOpen] = useState(false);
  const [allSubmitted, setAllSubmitted] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [image, setImage] = useState([]);
  const [formData, setFormData] = useState([]);
  const [Att, setAtt] = useState([]);
  const [removeSignOne, setRemoveSignOne] = useState("");
  const [removeSignTwo, setRemoveSignTwo] = useState("");

  const [filesList, setFileList] = useState([]);

  useEffect(() => {
    if (fireSuppressionViewId) {
      fetchTasks(fireSuppressionViewId);
      

    }
  }, [fireSuppressionViewId]);

  const fetchTasks = async (value) => {
    try {
      const response = await axiosInstance.get(
        `/collection-and-returns/form-fields/${value}`
      );
      const data = response.data?.data?.list;
      const formId = response.data?.data?.id;
      setIsSubmittted(response?.data?.data?.isFormVerified === false);
      setFormSubmitId(formId);
      setFormData(response.data.data);
      // setAtt(response.data.data);
checkAllSubmitted();
    checkOtpEnable();
      // Initialize rows with proper data
      const initializedRows = data.map((item) => ({
        ...item,
        extinguisherType: item.extinguisherType || "",
        unit: item.unit || "",
      }));

      setRows(initializedRows);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setAllFormValues([]);
    }
  };

  const checkAllSubmitted = async () => {
    try {
      const response = await axiosInstance.get(
        `/collection-and-returns/check-submitted/${fireSuppressionViewId}`
      );
      setAllSubmitted(response.data?.data === true);
    } catch (error) {
      console.error("Error checking submission status:", error);
    }
  };

  const toggleEdit = () => {
    setIsEditable((prev) => !prev);
  };

  const addRow = () => {
    setRows((prev) => [
      ...prev,
      {
        sno: prev.length + 1,
        location: "",
        extinguisherType: "",
        capacity: 0,
        unit: "",
        collectedQty: 0,
        returnedQty: 0,
        comments: "",
      },
    ]);
  };

  const handleChangeInput = (e, sno, field) => {
    const { value } = e.target;
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.sno === sno ? { ...row, [field]: value } : row
      )
    );
  };

  const handleSelectChange = (sno, field, value) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.sno === sno ? { ...row, [field]: value } : row
      )
    );
  };

  function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }

 async function CloseEditForm(id) {
  try {
    const res = await axiosInstance.put(
      `/collection-and-returns/close-form/${id}`
    );

    if (res?.data?.status) {
      setEditModeIndex(null);
      setIsEditable(false); // Disable editing mode
      fetchTasks(fireSuppressionViewId);
      toast.open({
        type: "success",
        message: "Success",
        description: "Form editing closed",
      });
    } else {
      toast.open({
        type: "error",
        message: "Error",
        description: res.data?.msg || "Failed to close form",
      });
    }
  } catch (error) {
    toast.open({
      type: "error",
      message: "Error",
      description: error?.response?.data?.msg || "Network error",
    });
  }
}

 async function OpenEditForm(isEditing, id, workingUser) {
  if (workingUser) {
    toast.open({
      type: "warning",
      message: "Warning",
      description: "Another user is currently editing this form",
    });
    return;
  }

  try {
    const res = await axiosInstance.put(
      `/collection-and-returns/open-form/${id}`
    );
    
    if (res?.data?.status) {
      fetchTasks(fireSuppressionViewId);
      setIsEditable(true); // Enable editing mode
      setEditModeIndex(isEditing);
      toast.open({
        type: "success",
        message: "Success",
        description: "Form is now editable",
      });
    } else {
      toast.open({
        type: "error",
        message: "Error",
        description: res.data?.msg || "Failed to open form for editing",
      });
    }
  } catch (error) {
    toast.open({
      type: "error",
      message: "Error",
      description: error?.response?.data?.msg || "Network error",
    });
  }
}


 function handleRemoveSignOne(){
   setRemoveSignOne("");
 }

  function handleRemoveSignTwo(){
   setRemoveSignTwo("");
 }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: yup.object({}),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async () => {
      let ValuesForForm = {
        isSubmitted: true,
        values: rows,
        filesToRemove: fileRemoveList,
        oldSign1: removeSignOne||"",
        oldSign2: removeSignTwo||"",
      };

      let formData = new FormData();
      formData.append("json_data", JSON.stringify(ValuesForForm));

      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }

      // Get signature data URLs
      const signature1DataURL = signOne.current?.toDataURL();
      const signature2DataURL = signTwo.current?.toDataURL();

      // Convert to blobs
      const signature1Blob = signature1DataURL
        ? dataURLtoBlob(signature1DataURL)
        : null;
      const signature2Blob = signature2DataURL
        ? dataURLtoBlob(signature2DataURL)
        : null;

      // Prepare signature1
      if (formData?.signature1?.file) {
        const signature1Blob = await fetch(formData.signature1.file).then(
          (res) => res.blob()
        );
        formData.append(
          "signature1",
          signature1Blob,
          `signature1-${formSubmitId}-${new Date().toISOString()}.png`
        );
      } else if (signOne.current && !signOne.current.isEmpty()) {
        const signature1DataURL = signOne.current.toDataURL();
        const signature1Blob = dataURLtoBlob(signature1DataURL);
        formData.append(
          "signature1",
          signature1Blob,
          `signature1-${formSubmitId}-${new Date().toISOString()}.png`
        );
      }

      // Prepare signature2
      if (formData?.signature2?.file) {
        const signature2Blob = await fetch(formData.signature2.file).then(
          (res) => res.blob()
        );
        formData.append(
          "signature2",
          signature2Blob,
          `signature2-${formSubmitId}-${new Date().toISOString()}.png`
        );
      } else if (signTwo.current && !signTwo.current.isEmpty()) {
        const signature2DataURL = signTwo.current.toDataURL();
        const signature2Blob = dataURLtoBlob(signature2DataURL);
        formData.append(
          "signature2",
          signature2Blob,
          `signature2-${formSubmitId}-${new Date().toISOString()}.png`
        );
      }

      try {
        const res = await axiosInstance.put(
          `/collection-and-returns/form-submition/${formSubmitId}`,
          formData
        );

        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
          setIsSubmittted(false);
          setSelectedFile([]);
          setImage([])
          CloseEditForm(formSubmitId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      } catch (error) {
        console.error("Submission Failed", error);
        toast.open({
          type: "error",
          message: "Error",
          description:
            error?.response?.data?.msg ||
            "Something went wrong while submitting.",
        });
      }
    },
  });

  async function SaveFormData() {
    let ValuesForForm = {
      isSubmitted: false,
      values: rows,
      filesToRemove: fileRemoveList,
      oldSign1: removeSignOne||"",
      oldSign2: removeSignTwo||"",
    };

    let formData = new FormData();
    formData.append("json_data", JSON.stringify(ValuesForForm));

    if (selectedFile !== null) {
      selectedFile.forEach((file) => {
        formData.append("attachments", file);
      });
    } else {
      formData.append("attachments", []);
    }

    // Convert canvas signatures to blobs
    const signature1DataURL = signOne.current?.toDataURL();
    const signature2DataURL = signTwo.current?.toDataURL();

    const signature1Blob = signature1DataURL
      ? dataURLtoBlob(signature1DataURL)
      : null;
    const signature2Blob = signature2DataURL
      ? dataURLtoBlob(signature2DataURL)
      : null;

    // Append signature1 if it exists and isn't empty
    if (signOne.current && !signOne.current.isEmpty() && signature1Blob) {
      formData.append(
        "signature1",
        signature1Blob,
        `signature1-${formSubmitId}-${new Date().toISOString()}.png`
      );
    }

    // Append signature2 if it exists and isn't empty
    if (signTwo.current && !signTwo.current.isEmpty() && signature2Blob) {
      formData.append(
        "signature2",
        signature2Blob,
        `signature2-${formSubmitId}-${new Date().toISOString()}.png`
      );
    }

    // Submit form
    axiosInstance
      .put(
        `/collection-and-returns/form-submition/${formSubmitId}`,
        formData
      )
      .then((res) => {
        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Saved Successfully.",
          });
          setIsEditable(false);
          setSelectedFile([]);
          setImage([])
          CloseEditForm(formSubmitId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      })
      .catch((error) => {
        console.error("Save Failed", error);
        toast.open({
          type: "error",
          message: "Error",
          description:
            error?.response?.data?.msg || "Something went wrong while saving.",
        });
      });
  }

  // Initialize signature components
  useEffect(() => {
    // Disable all signatures on initial load
    const disableSignatures = () => {
      [signOne, signTwo].forEach((signRef) => {
        if (signRef.current) signRef.current.off();
      });
    };

    const interval = setInterval(() => {
      disableSignatures();
      clearInterval(interval);
    }, 50);

    return () => clearInterval(interval);
  }, []);

  // Toggle signature enable/disable
  useEffect(() => {
    if (signOne.current) {
      isSignOneEnabled ? signOne.current.on() : signOne.current.off();
    }
  }, [isSignOneEnabled]);

  useEffect(() => {
    if (signTwo.current) {
      isSignTwoEnabled ? signTwo.current.on() : signTwo.current.off();
    }
  }, [isSignTwoEnabled]);

      function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileRemoveList, setFileRemoveList] = useState([]);

  useEffect(() => {
    if (
      formData?.attachments !== null &&
      formData?.attachments !== "None" &&
      formData?.attachments !== "[]"
    ) {
      console.log(formData?.attachments, "ghjkllgd");
      setFilePathList(formData?.attachments);

      setRemoveFilePathList(formData?.attachments || []);
    }
  }, [formData]);
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }

  function handleImageClick(img) {
    setSelectedImage(img);
    setIsModalOpen(true);
  }

  const handleSendOTP = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = () => {
    setExpandedIndex(expandedIndex === null ? 0 : null); 
  };

   const [otpEnable, setOtpEnable] = useState(false);
    const [openEnable, setEnableOpen] = useState(false);
    const [loading, setLoading] = useState(false);
  
    // Fetch OTP enable status
    const checkOtpEnable = async () => {
      try {
        const response = await axiosInstance.get(`/collection-and-returns/is-otp-enabled`);
        console.log("Check Submitted Status", response.data);
  
        if (response.data?.status) {
          setOtpEnable(response.data.data === true);
        } else {
          console.warn("Unexpected response status:", response.data);
          setOtpEnable(false);
        }
      } catch (error) {
        console.error("Error checking submission status:", error);
        setOtpEnable(false);
      }
    };
  
    // On button click, open confirm popup
    const handleEnableOTP = () => setEnableOpen(true);
  
    // On confirm, call verify API
    const handleVerifyOTP = () => {
      setLoading(true);
      axiosInstance
        .put(`/collection-and-returns/verify-otp/${fireSuppressionViewId}`,{opt:""})
        .then((res) => {
          if (res.data.status) {
            toast.open({
              type: "success",
              message: "OTP Verified",
            });
            fetchTasks(fireSuppressionViewId);
           
          } else {
            toast.open({
              type: "error",
              message: "Invalid OTP",
              description: res.data.msg,
            });
          }
        })
        .catch((err) => {
          toast.open({
            type: "error",
            message: "Network Error",
            description: err.message,
          });
        })
        .finally(() => {
          setLoading(false);
          setEnableOpen(false);
        });
    };
  
    // On page load, check status and fetch tasks
    useEffect(() => {
      checkOtpEnable();
      fetchTasks(fireSuppressionViewId);
    }, [fireSuppressionViewId]);



    useEffect(() => {
      if (formData?.signature1?.file) {
        setRemoveSignOne(formData?.signature1?.file);
      }
      if (formData?.signature2?.file) {
        setRemoveSignTwo(formData?.signature2?.file);
      }
    },[formData])
  
    const handleDeleteRow = (sno) => {
  if (rows.length <= 1) {
    toast.open({
      type: "warning",
      message: "Warning",
      description: "You must have at least one row",
    });
    return;
  }
  
  setRows(prevRows => prevRows.filter(row => row.sno !== sno));
};

  return (
    <FireSuppressionLayout BackButtonAccess={true}>
      <div className="w-full h-full px-2">
        <div className="w-full px-2 h-[calc(100vh-145px)] bg-gray-100 rounded-lg overflow-x-auto">
          {/* Table header */}
                   <div className="bg-white h-auto sm:flex items-center justify-end font-semibold text-xs rounded-t-lg px-2 overflow-hidden sticky top-0 z-50">
     <div className="sm:flex gap-4 justify-end w-[85%] items-center p-2 cursor-pointer bg-white ">
              {formData?.workingUser != null && (
             <div className=" flex items-center  overflow-hidden rounded-full text-[10px] 2xl:text-xs   ">
                <div className="  p-2 h-6  bg-white rounded-s-full font-medium flex items-center border border-emerald-300">
                  Inspector{" "}
                </div>
                <div className="  p-2 h-6  bg-emerald-300 text-white font-medium rounded-e-full flex items-center">
                  {formData?.workingUserName || "No User"}
                </div>
              </div>
              )} 
{formData?.updatedByName &&
              <div className="flex mt-2 sm:mt-0 items-center overflow-hidden rounded-full text-[10px] 2xl:text-xs border border-blue-400 w-fit">
      <div className="flex items-center bg-white px-2 h-6 rounded-full  font-medium">
    Updated By
  </div>

  {/* Right Capsule */}
  <div className="flex flex-col justify-center bg-blue-400 text-white font-medium px-3 h-6 rounded-e-full">
    <div className="text-[11px]">{formData?.updatedByName || "No User"}</div>
    <div className="flex gap-0.5 text-[9px] text-gray-200">
      <span>
        <NuDate value={formData?.updatedAt} format="DD-MMM-YYYY," />
      </span>
      <span>
        <NuDate value={formData?.updatedAt} format="hh:mm a" />
      </span>
    </div>
  </div>
</div>}

              <div className=" flex mt-2 sm:mt-0 items-center  overflow-hidden rounded-full text-[10px] 2xl:text-xs   ">
                <div className="  p-2 h-6  bg-white  rounded-s-full font-medium flex items-center border border-green-700">
                  Status{" "}
                </div>
                <div className="  p-2 h-6  bg-green-700 text-white font-medium  rounded-e-full flex items-center">
                  {formData?.status || "None"}
                </div>
              </div>

              <div className=" flex sm:mt-0 mt-2  items-center  overflow-hidden rounded-full text-[10px] 2xl:text-xs   ">
                <div className="  p-1 h-6  bg-white  px-1 rounded-s-full font-medium flex items-center border border-yellow-400">
                  Completion Date{" "}
                </div>
                <div className="  p-1 h-6  bg-yellow-400 px-1 text-white rounded-e-full flex flex-col justify-center font-medium ">
                  <div className=" text-[10px] line-clamp-1">
                    {" "}
                    <NuDate
                      value={formData?.dateTime}
                      format="DD-MMM-YYYY,hh:mm a"
                    />
                  </div>
                  {/* <div className=" text-[9px]">
                                           <NuDate value={formData?.dateTime} format="" />
           
                                         </div> */}
                </div>
              </div>
            </div>
            <div className="sm:flex gap-4 justify-end sm:w-[15%]">
             {GetAccess("fire_extinguisher_form_edit") && (GetRole()||isSubmittted) && (
  <span
    onClick={() => {
      if (isEditing) {
        CloseEditForm(formSubmitId);
      } else {
        OpenEditForm(true, formSubmitId, formData?.workingUser);
      }
    }}
    className={`cursor-pointer mr-2 p-1 ml-2 sm:ml-0 rounded-lg border w-6 h-6 flex items-center justify-center
      ${isEditing ? "bg-green-100 border-green-500" : "bg-red-100 border-red-300"}`}
  >
    <EditIcon
      color={isEditing ? "green" : "red"}
      height={12}
    />
  </span>
)}
              <span
          onClick={handleToggle}
          className={`cursor-pointer mt-2 sm:mt-0 p-1 w-auto h-auto rounded-lg border transition flex items-center justify-center 
            ${expandedIndex !== null ? "bg-blue-100 border-blue-500" : "bg-gray-100 border-gray-300"}`}
        >
          {expandedIndex !== null ? <ToggleUp /> : <ToggleDown />}
        </span>
               {isEditing && (
              <button
                onClick={addRow}
                type="button"
                className="p-1 bg-gray-100 border  font-medium text-[16px] text-black rounded-lg"
              >
                +
              </button>)}
            </div>
          </div>
                 <div className="flex items-center sm:mt-0 mt-2 bg-textColor-main text-white font-semibold text-xs rounded-t-lg px-2 sticky top-12 z-40">
      <div className="w-[5%] p-2">Ref no.</div>
            <div className="w-[15%] p-2">Location</div>
            <div className="w-[15%] p-2">Suppression Type</div>
            <div className="w-[10%] p-2">Capacity</div>
            <div className="w-[10%] p-2">Unit</div>
            <div className="w-[10%] p-2">Collected Qty.</div>
            <div className="w-[10%] p-2">Return Qty.</div>
            <div className="w-[20%] p-2">Comments</div>
            <div className="w-[5%] p-2 flex gap-2 text-right items-end justify-end">
             
            </div>
          </div>
{expandedIndex !== null && (
          <form onSubmit={formik.handleSubmit}>
            {/* Table rows */}
            <div className="h-[calc(100vh-250px)] overflow-y-auto">
              {rows?.map((row, index) => (
                <div
                  key={index}
                  className="flex items-center bg-white text-sm border-b border-gray-300"
                >
                  <div className="w-[5%] p-2">{index + 1}</div>
                  <div className="w-[15%] p-2">
                    <input
                      placeholder="Location"
                      disabled={!isEditing}
                      value={row?.location || ""}
                      onChange={(e) =>
                        handleChangeInput(e, row.sno, "location")
                      }
                      className="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                    />
                  </div>
                  <div className="w-[15%] p-2">
                    <select
                      disabled={!isEditing}
                      value={row?.extinguisherType || ""}
                      onChange={(e) =>
                        handleSelectChange(
                          row.sno,
                          "extinguisherType",
                          e.target.value
                        )
                      }
                      className="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                    >
                      <option value="">Select Type</option>
                      {suppression?.map((item, idx) => (
                        <option key={idx} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="w-[10%] p-2">
                    <input
                      type="number"
                      placeholder="Capacity"
                      disabled={!isEditing}
                      value={row?.capacity || ""}
                      onChange={(e) =>
                        handleChangeInput(e, row.sno, "capacity")
                      }
                      className="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                    />
                  </div>

                  <div className="w-[10%] p-2">
                    <select
                      disabled={!isEditing}
                      value={row?.unit || ""}
                      onChange={(e) =>
                        handleSelectChange(row.sno, "unit", e.target.value)
                      }
                      className="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                    >
                      <option value="">Select Unit</option>
                      {unit?.map((item, idx) => (
                        <option key={idx} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="w-[10%] p-2">
                    <input
                      type="number"
                      placeholder="Quantity"
                      disabled={!isEditing}
                      value={row?.collectedQty || ""}
                      onChange={(e) =>
                        handleChangeInput(e, row.sno, "collectedQty")
                      }
                      className="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                    />
                  </div>

                  <div className="w-[10%] p-2">
                    <input
                      type="number"
                      placeholder="Quantity"
                      disabled={!isEditing}
                      value={row?.returnedQty || ""}
                      onChange={(e) =>
                        handleChangeInput(e, row.sno, "returnedQty")
                      }
                      className="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                    />
                  </div>

                  <div className="w-[20%] p-2">
                    <textarea
                      placeholder="Comments"
                      disabled={!isEditing}
                      value={row?.comments || ""}
                      onChange={(e) =>
                        handleChangeInput(e, row.sno, "comments")
                      }
                      className="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                    />
                  </div>
                   <div className="w-[5%] p-2 flex gap-2 text-right items-end justify-end">
                        {isEditing && (
                          <button
                            type="button"
                            onClick={() => handleDeleteRow(row.sno)}
                            className="text-red-500 hover:text-red-700"
                          >
                                      <DeleteIcon color="red" height={12} />

                          </button>
                        )}
                      </div>
                             
                </div>
              ))}

              {/* <div className="w-full grid md:grid-cols-2 gap-6 py-2 px-2 mb-10">
                <div className="relative border w-full h-64 p-2 rounded-md bg-white">
                  {formData?.signature1?.file ? (
                    <img
                      src={formData.signature1.file}
                      alt="Collector Signature"
                      className="border border-gray-400 w-full h-52 rounded-md object-contain"
                    />
                  ) : (
                    <SignatureCanvas
                      penColor="black"
                      canvasProps={{
                        className:
                          "border border-gray-400 w-full h-52 rounded-md",
                          disabled: !isEditing
                      }}
                      ref={signOne}
                    />
                  )}

                  <div className="flex justify-between items-center mt-1">
                    <span className="text-xs font-semibold text-gray-500">
                      Collector :
                    </span>
                    <div className="flex gap-3">
                      <button
                        type="button"
                        disabled={!isEditing}
                        onClick={() => {
                          if (!isEditing) return; 
                          if (formData?.signature1?.file) {
                            // Clear the uploaded signature
                            setFormData((prev) => ({
                              ...prev,
                              signature1: null,
                            }));
                          } else if (isSignOneEnabled) {
                            signOne.current.clear();
                            setIsSignOneEnabled(false);
                            setShowActionButtonsOne(false);
                            setSignOneURL(null);
                          } else {
                            setIsSignOneEnabled(true);
                            setShowActionButtonsOne(true);
                          }
                        }}
                        className={`text-xs px-3 py-1 rounded-md font-medium ${
                          formData?.signature1?.file || isSignOneEnabled
                            ? "bg-red-500 text-white"
                            : "bg-gray-200 text-textColor-main"
                        }`}
                      >
                        {formData?.signature1?.file || isSignOneEnabled
                          ? "Remove"
                          : "Add Signature"}
                      </button>

                      {!formData?.signature1?.file && showActionButtonsOne && (
                        <>
                          <button
                            type="button"
                            disabled={!isEditing}
                            onClick={() => {
                              signOne.current.clear();
                              setSignOneURL(null);
                            }}
                            className="text-xs text-textColor-main px-3 py-1 rounded-md bg-gray-200"
                          >
                            Reset
                          </button>
                          <button
                            type="button"
                            disabled={!isEditing}
                            onClick={() => {
                              if (signOne.current.isEmpty()) {
                                alert("Please provide a signature first");
                                return;
                              }
                              const dataURL =
                                signOne.current.toDataURL("image/png");
                              setSignOneURL(dataURL);
                              setIsSignOneEnabled(false);
                              setShowActionButtonsOne(false);
                            }}
                            className="text-xs px-3 py-1 rounded-md font-medium bg-green-500 text-white"
                          >
                            Save
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="relative border w-full h-64 p-2 rounded-md bg-white">
                  {formData?.signature2?.file ? (
                    <img
                      src={formData.signature2.file}
                      alt="Client Signature"
                      className="border border-gray-400 w-full h-52 rounded-md object-contain"
                    />
                  ) : (
                    <SignatureCanvas
                      penColor="black"
                      canvasProps={{
                        className:
                          "border border-gray-400 w-full h-52 rounded-md",
                          disabled: !isEditing
                      }}
                      ref={signTwo}
                    />
                  )}

                  <div className="flex justify-between items-center mt-1">
                    <span className="text-xs font-semibold text-gray-500">
                      Client :
                    </span>
                    <div className="flex gap-3">
                      <button
                        type="button"
                        disabled={!isEditing}
                        onClick={() => {
                          if (!isEditing) return; 
                          if (formData?.signature2?.file) {
                            setFormData((prev) => ({
                              ...prev,
                              signature2: null,
                            }));
                          } else if (isSignTwoEnabled) {
                            signTwo.current.clear();
                            setIsSignTwoEnabled(false);
                            setShowActionButtonsTwo(false);
                            setSignTwoURL(null);
                          } else {
                            setIsSignTwoEnabled(true);
                            setShowActionButtonsTwo(true);
                          }
                        }}
                        className={`text-xs px-3 py-1 rounded-md font-medium ${
                          formData?.signature2?.file || isSignTwoEnabled
                            ? "bg-red-500 text-white"
                            : "bg-gray-200 text-textColor-main"
                        }`}
                      >
                        {formData?.signature2?.file || isSignTwoEnabled
                          ? "Remove"
                          : "Add Signature"}
                      </button>

                      {!formData?.signature2?.file && showActionButtonsTwo && (
                        <>
                          <button
                            type="button"
                            disabled={!isEditing}
                            onClick={() => {
                              signTwo.current.clear();
                              setSignTwoURL(null);
                            }}
                            className="text-xs text-textColor-main px-3 py-1 rounded-md bg-gray-200"
                          >
                            Reset
                          </button>
                          <button
                            type="button"
                            disabled={!isEditing}
                            onClick={() => {
                              if (signTwo.current.isEmpty()) {
                                alert("Please provide a signature first");
                                return;
                              }
                              const dataURL =
                                signTwo.current.toDataURL("image/png");
                              setSignTwoURL(dataURL);
                              setIsSignTwoEnabled(false);
                              setShowActionButtonsTwo(false);
                            }}
                            className="text-xs text-white px-3 py-1 rounded-md bg-blue-500"
                          >
                            Save
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Attachement :
                </p>
              </div>
               <Attachement
                    handleChange={handleImageChange}
                    preview={image || ""}
                    width="w-full md:w-1/2"
                    label="Attach"
                    multiple={true}
                    removeImages={removeImages}
                      disabled={!isEditing}

                  />
          <div className="md:flex justify-between mt-5 px-3 w-full">
                <div className="w-full flex gap-2 items-center flex-wrap">
                  {filePathList &&
                    filePathList?.map((imgs, idx) => {
                      console.log("img", imgs);
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return (
                        <div
                          className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                          key={idx}
                          style={{
                            border: "1px solid gray",
                            borderColor:
                              "rgb(148 163 184 / var(--tw-bg-opacity))",
                          }}
                        >
                         <div
  className="w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center -top-2 -right-2 z-10"
  onClick={() => {
    if (isEditing) {
      UpdateAttachmentList(imgs?.file);
    }
  }}
>
  <CloseIcon color="white" height="8" width="8" />
</div>

                          <div
                            className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => handleImageClick(imgs)}
                          >
                            <div className=" w-8 h-8">
                              {videotype.includes(Ext) ? <Video /> : null}

                              {Ext === ("docx" || "doc" || "txt") ? (
                                <Doc />
                              ) : Ext === ("xlsx" || "xls") ? (
                                <Xls />
                              ) : Ext === "txt" ? (
                                <Txt />
                              ) : Ext === "pdf" ? (
                                <Pdf />
                              ) : Ext === "pptx" ? (
                                <>No file</>
                              ) : (
                                <img src={imgs?.file} alt="#" width="120%" />
                              )}
                            </div>
                            <p className=" w-[50px] text-[11px] truncate">
                              {imgs?.file_name}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                 
                </div>
              </div>

              {rows?.length !== 0 && isEditing && (
  <div className="w-full flex justify-end items-center gap-2 py-2 px-2 mb-10">
    <CancelButton
      name="Save" 
      handleClick={SaveFormData}
    />
    <SubmitButton />
  </div>
)}
            </div>
          </form>
)}
          {allSubmitted && isSubmittted && otpEnable &&(
            <div className="w-full p-4 flex justify-end">
              <SubmitButton name="Verify with OTP" handleClick={handleSendOTP} />
            </div>
          )}
           {!otpEnable && isSubmittted &&(
        <div className="w-full p-4 flex justify-end">
          <SubmitButton name="Verify" handleClick={handleEnableOTP} />
        </div>
      )}
        </div>
      </div>

      {open && (
        <SendOTP
          fireSuppressionViewId={fireSuppressionViewId}
          onClose={handleCloseModal}
          fetchTasks={fetchTasks}
        />
      )}
      {openEnable && (
        <ModalContainer
          visiable={openEnable}
          title="Confirm"
          content={
            <div>
              <p>
                Are You Sure! You want to{" "}
                <span className="font-semibold">Verify</span> this Form?
              </p>
            </div>
          }
          handleClick={handleVerifyOTP}
          closeModal={() => setEnableOpen(false)}
          isLoading={loading}
        />
      )}
    </FireSuppressionLayout>
  );
}

export default FeFormView;


